import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { LINK_URL_SHORTENER_GUIDE } from 'shared/constants/links'
import { useUrlShortenerContext } from 'pages/settings/pages/urlShortener/context/UrlShortenerContext'

export const AddDomainButton = observer(({ className }: { className?: string }) => {
  const store = useUrlShortenerContext()

  return (
    <Button
      text='Add domain'
      size='medium'
      iconProps={{ icon: 'add' }}
      onClick={() => {
        store.urlShortenerModalStore.reset()
        store.urlShortenerModalStore.openAddCustomDomainModal()
      }}
      className={className}
    />
  )
})

export const GuideButton = observer(({ className }: { className?: string }) => (
  <Button
    className={className}
    tag={'a'}
    href={LINK_URL_SHORTENER_GUIDE}
    text='Help guide'
    target='_blank'
    rel='noreferrer'
    size='medium'
    contained='secondary'
    iconProps={{ icon: 'info' }}
  />
))

export const ActivateButton = observer(() => {
  const { urlShortenerModalStore, isStatusPendingPayment, isStatusUnsubscribed } =
    useUrlShortenerContext()

  if (!isStatusPendingPayment && !isStatusUnsubscribed) return null

  return (
    <Button
      text='Activate'
      size='small'
      contained='primary'
      onClick={urlShortenerModalStore.openActivateCustomDomainModal}
    />
  )
})
